module.exports = __webpack_public_path__ + "img/terraform.1312f563.png";